import type { ReactStoryblokComponent } from "types/storyblok";
import { WhyChooseAirHelp } from "modules/sections/WhyChooseAirHelp";
import type { WhyChooseAirHelpProps } from "modules/sections/WhyChooseAirHelp/WhyChooseAirHelp.d";

const WhyChooseAirHelpSectionAdapter = ({
  sbEditable,
  blok: { title, cards, backgroundColor },
}: ReactStoryblokComponent<WhyChooseAirHelpProps>) => (
  <WhyChooseAirHelp title={title} cards={cards} sbEditable={sbEditable} backgroundColor={backgroundColor} />
);
export default WhyChooseAirHelpSectionAdapter;
